'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryQuotationEditor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _utilsLocalization = require('@bibliocommons/utils-localization');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseLoader = require('@bibliocommons/base-loader');

var _baseLoader2 = _interopRequireDefault(_baseLoader);

var _baseAlerts = require('@bibliocommons/base-alerts');

var _baseIcons = require('@bibliocommons/base-icons');

var _loginLink = require('../../login-link');

var _loginLink2 = _interopRequireDefault(_loginLink);

var _simpleUgcForm = require('../../simple-ugc-form');

var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrimaryQuotationEditor = exports.PrimaryQuotationEditor = function (_BcReactComponent) {
  _inherits(PrimaryQuotationEditor, _BcReactComponent);

  function PrimaryQuotationEditor() {
    _classCallCheck(this, PrimaryQuotationEditor);

    return _possibleConstructorReturn(this, (PrimaryQuotationEditor.__proto__ || Object.getPrototypeOf(PrimaryQuotationEditor)).apply(this, arguments));
  }

  _createClass(PrimaryQuotationEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* For Testing purposes */}
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          characterLimit = _props.characterLimit,
          intl = _props.intl,
          handleChange = _props.handleChange,
          handleLogin = _props.handleLogin,
          handleSubmit = _props.handleSubmit,
          initializingStatus = _props.initializingStatus,
          user = _props.user;


      if (initializingStatus.status === 'pending') {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_baseLoader2.default, null)
        );
      }

      if (initializingStatus.status === 'failure') {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _baseAlerts.AlertFailure,
            null,
            _react2.default.createElement('span', { className: 'icon-ok' }),
            (0, _utilsLocalization.localizeFromKey)(initializingStatus, intl)
          )
        );
      }

      if (user.loggedIn) {
        return _react2.default.createElement(
          'div',
          { className: 'cp-primary-quotation-editor well clearfix' },
          _react2.default.createElement(_simpleUgcForm2.default, {
            characterLimit: characterLimit,
            body: '',
            ugcType: 'quotation',
            placeholderText: 'quotation_field_placeholder',
            submitButtonText: 'add_quotation',
            formHeadingText: 'enter_a_quotation',
            handleChange: handleChange,
            handleSubmit: handleSubmit,
            isNew: true })
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'well' },
        _react2.default.createElement(
          _loginLink2.default,
          { handleLogin: handleLogin },
          _react2.default.createElement(_baseIcons.Quotation, null),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'login_to_add_quotation' })
        )
      );
    }
  }]);

  return PrimaryQuotationEditor;
}(_baseBcReactComponent2.default);

PrimaryQuotationEditor.propTypes = {
  initializingStatus: _react.PropTypes.shape({
    status: _react.PropTypes.string
  }).isRequired,
  characterLimit: _react.PropTypes.number,
  quotation: _react.PropTypes.string,
  handleChange: _react.PropTypes.func.isRequired,
  handleLogin: _react.PropTypes.func.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.shape({
    loggedIn: _react.PropTypes.bool
  }).isRequired,
  intl: _reactIntl.intlShape
};

exports.default = (0, _reactIntl.injectIntl)(PrimaryQuotationEditor);


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/primary-quotation-editor/components/PrimaryQuotationEditor.js
// module id = 1036
// module chunks = 4